var render = function render(){
  var _vm$selectedInput$loc, _vm$selectedInput$loc4, _vm$staged$inputs;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }), _c('dialog-scroll-lock', {
    attrs: {
      "width": "300"
    },
    model: {
      value: _vm.showReset,
      callback: function ($$v) {
        _vm.showReset = $$v;
      },
      expression: "showReset"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Are you sure you want to reset the RSVP form?")]), _c('v-list', {
    staticClass: "primary--text",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "simple px-6",
    on: {
      "click": function ($event) {
        return _vm.reset(true);
      }
    }
  }, [_c('div', [_c('div', [_vm._v("Reset to default form")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Includes inputs for counting attendees")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-list-item', {
    staticClass: "simple px-6",
    on: {
      "click": function ($event) {
        return _vm.reset(false);
      }
    }
  }, [_c('div', [_c('div', [_vm._v("Reset to empty form")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Fully customizable")])]), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "orange"
    },
    on: {
      "click": function ($event) {
        _vm.showReset = false;
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 1)], 1), _vm.$refs.opts && _vm.$refs.opts[_vm.staged.inputs.indexOf(_vm.selectedInput)] ? _c('v-menu', {
    attrs: {
      "right": "",
      "nudge-top": "8",
      "offset-x": "",
      "close-on-content-click": false,
      "activator": _vm.$refs.opts[_vm.staged.inputs.indexOf(_vm.selectedInput)].$el,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selectedInput = null;
      }
    }
  }, [_vm.selectedInput ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm.selectedInput.type == 'INT' && !((_vm$selectedInput$loc = _vm.selectedInput.lock) !== null && _vm$selectedInput$loc !== void 0 && _vm$selectedInput$loc.includes('range')) ? _c('div', {
    staticClass: "d-flex px-2"
  }, [_c('int-field', {
    staticClass: "ma-2",
    attrs: {
      "label": "Min value",
      "hide-stepper": "",
      "rules": [function (v) {
        return parseInt(v) < _vm.selectedInput.max;
      }]
    },
    model: {
      value: _vm.selectedInput.min,
      callback: function ($$v) {
        _vm.$set(_vm.selectedInput, "min", $$v);
      },
      expression: "selectedInput.min"
    }
  }), _c('int-field', {
    staticClass: "ma-2",
    attrs: {
      "label": "Max value",
      "hide-stepper": "",
      "rules": [function (v) {
        return parseInt(v) > _vm.selectedInput.min;
      }]
    },
    model: {
      value: _vm.selectedInput.max,
      callback: function ($$v) {
        _vm.$set(_vm.selectedInput, "max", $$v);
      },
      expression: "selectedInput.max"
    }
  })], 1) : _vm._e(), _vm._l(_vm.options, function (_ref) {
    var _vm$selectedInput$loc2, _vm$selectedInput$loc3;
    var key = _ref[0],
      subtitle = _ref[1];
    return _c('v-list-item', {
      key: key,
      staticClass: "py-2",
      attrs: {
        "disabled": !!((_vm$selectedInput$loc2 = _vm.selectedInput.lock) !== null && _vm$selectedInput$loc2 !== void 0 && _vm$selectedInput$loc2.includes(key))
      },
      on: {
        "click": function ($event) {
          return _vm.$set(_vm.selectedInput, key, !_vm.selectedInput[key]);
        }
      }
    }, [_c('v-checkbox', {
      staticClass: "my-0 py-0 mr-2",
      attrs: {
        "readonly": "",
        "hide-details": "",
        "disabled": !!((_vm$selectedInput$loc3 = _vm.selectedInput.lock) !== null && _vm$selectedInput$loc3 !== void 0 && _vm$selectedInput$loc3.includes(key)),
        "input-value": _vm.selectedInput[key]
      }
    }), _c('div', [_c('div', {
      staticStyle: {
        "line-height": "1.2em",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(key))]), _c('div', {
      staticClass: "text--label-active"
    }, [_vm._v(_vm._s(subtitle))])])], 1);
  }), !((_vm$selectedInput$loc4 = _vm.selectedInput.lock) !== null && _vm$selectedInput$loc4 !== void 0 && _vm$selectedInput$loc4.includes('delete')) ? _c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.deleteSection(_vm.staged.inputs.indexOf(_vm.selectedInput)).then(function () {
          return _vm.selectedInput = null;
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDelete)
    }
  }), _c('div', {
    staticClass: "warning--text"
  }, [_vm._v("Delete")])], 1) : _vm._e()], 2) : _vm._e()], 1) : _vm._e(), _c('v-btn', {
    staticClass: "absolute",
    staticStyle: {
      "top": "12px",
      "right": "12px"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.tryClose
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("RSVP form")]), _c('v-card-subtitle', [_vm._v("Design your own custom RSVP form")]), _c('v-divider'), (_vm$staged$inputs = _vm.staged.inputs) !== null && _vm$staged$inputs !== void 0 && _vm$staged$inputs.length ? _c('div', {
    staticClass: "pl-9"
  }, [_c('draggable', {
    staticStyle: {
      "min-height": "80px"
    },
    attrs: {
      "draggable": ".draggable",
      "handle": ".draggable-handle",
      "ghost-class": "draggable-ghost",
      "move": function (e) {
        return !e.related.classList.contains('draggable-disabled');
      }
    },
    model: {
      value: _vm.staged.inputs,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "inputs", $$v);
      },
      expression: "staged.inputs"
    }
  }, _vm._l(_vm.staged.inputs, function (input, i) {
    var _input$lock, _input$lock2, _input$lock3, _input$lock4, _input$lock5, _input$lock6, _input$lock7, _input$lock8, _input$lock10;
    return _c('div', {
      staticClass: "py-6 draggable d-flex align-center relative",
      class: {
        'draggable-disabled': !!((_input$lock = input.lock) !== null && _input$lock !== void 0 && _input$lock.includes('move'))
      }
    }, [_c('div', {
      staticClass: "absolute d-flex flex-column btn-group btn-group-vertical",
      staticStyle: {
        "left": "-28px"
      }
    }, [!((_input$lock2 = input.lock) !== null && _input$lock2 !== void 0 && _input$lock2.includes('move')) ? _c('v-btn', {
      staticClass: "draggable-handle",
      staticStyle: {
        "cursor": "grab"
      },
      attrs: {
        "fab": "",
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiArrowSplitHorizontal)
      }
    }), _c('span', {
      staticClass: "btn-tooltip right"
    }, [_vm._v("Drag to rearrange")])], 1) : _vm._e(), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !input.root,
        expression: "!input.root"
      }],
      ref: "opts",
      refInFor: true,
      attrs: {
        "fab": "",
        "small": ""
      },
      on: {
        "click": function () {
          var wasOpen = _vm.selectedInput === input;
          _vm.selectedInput = null;
          if (!wasOpen) _vm.$nextTick(function () {
            return _vm.selectedInput = input;
          });
        }
      }
    }, [_c('v-icon', {
      style: {
        transform: _vm.selectedInput === input ? 'rotate(90deg)' : null
      },
      attrs: {
        "color": "primary"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiDotsHorizontal)
      }
    }), _c('span', {
      staticClass: "btn-tooltip right"
    }, [_vm._v("Settings")])], 1)], 1), input.conditional ? _c('div', {
      staticClass: "pl-5"
    }, [_c('div', {
      staticClass: "absolute",
      staticStyle: {
        "top": "12px",
        "bottom": "12px",
        "width": "16px",
        "border": "thin dashed #9e9e9e",
        "border-right": "none"
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "px-5",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('content-editable-div', {
      ref: "editable-title",
      refInFor: true,
      staticClass: "title preserve-newlines",
      class: {
        'mb-1': !((_input$lock3 = input.lock) !== null && _input$lock3 !== void 0 && _input$lock3.includes('title')),
        'success--text': input.public || input.root
      },
      attrs: {
        "disabled": !!((_input$lock4 = input.lock) !== null && _input$lock4 !== void 0 && _input$lock4.includes('title')),
        "error": !((_input$lock5 = input.lock) !== null && _input$lock5 !== void 0 && _input$lock5.includes('title')) && input.dirty && input.errors.title,
        "placeholder": input.type == 'HEADER' ? 'Title' : 'RSVP question'
      },
      scopedSlots: _vm._u([{
        key: "suffix",
        fn: function () {
          return [input.required ? _c('span', {
            staticClass: "error--text",
            staticStyle: {
              "vertical-align": "top"
            }
          }, [_vm._v(" *")]) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: input.title,
        callback: function ($$v) {
          _vm.$set(input, "title", $$v);
        },
        expression: "input.title"
      }
    }), !((_input$lock6 = input.lock) !== null && _input$lock6 !== void 0 && _input$lock6.includes('title')) && input.dirty && input.errors.title ? _c('v-card', {
      staticClass: "text--label-active absolute error--text",
      staticStyle: {
        "z-index": "1",
        "padding": "0 1px",
        "margin": "-9px 0 0 2px",
        "pointer-events": "none"
      },
      attrs: {
        "flat": ""
      }
    }, [_vm._v(" " + _vm._s(input.errors.title) + " ")]) : _vm._e(), !((_input$lock7 = input.lock) !== null && _input$lock7 !== void 0 && _input$lock7.includes('subtitle')) || input.subtitle ? _c('content-editable-div', {
      ref: "editable-subtitle",
      refInFor: true,
      staticClass: "pa-0 v-card__subtitle preserve-newlines mb-2",
      staticStyle: {
        "color": "rgba(0, 0, 0, 0.6)"
      },
      attrs: {
        "placeholder": "Details",
        "disabled": !!((_input$lock8 = input.lock) !== null && _input$lock8 !== void 0 && _input$lock8.includes('subtitle')),
        "error": input.dirty && input.errors.subtitle
      },
      model: {
        value: input.subtitle,
        callback: function ($$v) {
          _vm.$set(input, "subtitle", $$v);
        },
        expression: "input.subtitle"
      }
    }) : _vm._e(), input.type == 'RADIO' ? _c('div', [input.lock ? _c('v-radio-group', {
      staticClass: "mt-1 py-0",
      attrs: {
        "readonly": "",
        "hide-details": "",
        "row": input.row
      }
    }, _vm._l(input.choices, function (choice, j) {
      return _c('v-radio', {
        key: i + '.' + j,
        attrs: {
          "disabled": "",
          "label": choice
        }
      });
    }), 1) : _vm._l(input.choices, function (choice, j) {
      return _c('div', {
        staticClass: "d-flex align-center relative",
        staticStyle: {
          "margin-left": "-6px"
        }
      }, [_c('v-btn', {
        attrs: {
          "icon": "",
          "color": "warning",
          "disabled": input.choices.length <= 2
        },
        on: {
          "click": function ($event) {
            var _input$lock9;
            ((_input$lock9 = input.lock) === null || _input$lock9 === void 0 ? void 0 : _input$lock9.includes('choices')) || input.choices.splice(j, 1);
          }
        }
      }, [_c('v-icon', {
        domProps: {
          "innerHTML": _vm._s(_vm.mdiMinus)
        }
      })], 1), _c('div', {
        staticClass: "flex-grow-1",
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
          }
        }
      }, [_c('content-editable-div', {
        ref: 'editable-option-' + i,
        refInFor: true,
        staticClass: "px-1",
        staticStyle: {
          "color": "rgba(0, 0, 0, 0.6)"
        },
        attrs: {
          "placeholder": 'Option ' + (j + 1),
          "error": input.dirty && input.errors.choices && input.errors.choices[j]
        },
        model: {
          value: input.choices[j],
          callback: function ($$v) {
            _vm.$set(input.choices, j, $$v);
          },
          expression: "input.choices[j]"
        }
      })], 1), input.dirty && input.errors.choices && input.errors.choices[j] ? _c('v-card', {
        staticClass: "text--label-active absolute error--text",
        staticStyle: {
          "z-index": "1",
          "padding": "0 2px",
          "left": "38px",
          "bottom": "-3px",
          "pointer-events": "none"
        },
        attrs: {
          "flat": ""
        }
      }, [_vm._v(" " + _vm._s(input.errors.choices[j]) + " ")]) : _vm._e()], 1);
    }), !((_input$lock10 = input.lock) !== null && _input$lock10 !== void 0 && _input$lock10.includes('choices')) ? _c('v-btn', {
      staticStyle: {
        "margin-left": "-6px"
      },
      attrs: {
        "color": "primary",
        "icon": ""
      },
      on: {
        "click": function () {
          var k = input.choices.push('') - 1;
          _vm.$nextTick(function () {
            return _vm.$refs['editable-option-' + i][k].$refs.content.focus();
          });
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiPlus)
      }
    })], 1) : _vm._e()], 2) : input.type == 'ATTENDEE_SEPARATE_COUNTS' ? _c('div', [_c('int-field', {
      staticClass: "mb-3",
      staticStyle: {
        "width": "180px"
      },
      attrs: {
        "label": "Adults",
        "disabled": ""
      }
    }), _c('br'), _c('int-field', {
      staticStyle: {
        "width": "180px"
      },
      attrs: {
        "label": "Children",
        "disabled": ""
      }
    })], 1) : input.type == 'INT' ? _c('int-field', {
      staticClass: "d-flex",
      staticStyle: {
        "width": "180px"
      },
      attrs: {
        "disabled": ""
      }
    }) : input.type == 'TEXT' ? _c('v-textarea', {
      staticClass: "mt-2",
      attrs: {
        "outlined": "",
        "hide-details": "",
        "auto-grow": "",
        "disabled": "",
        "placeholder": input.placeholder
      }
    }) : input.type == 'TEXT_SHORT' ? _c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "outlined": "",
        "dense": "",
        "hide-details": "",
        "disabled": "",
        "placeholder": input.placeholder
      }
    }) : input.type == 'ATTENDEE_NAMES' ? _c('div', {
      staticClass: "mt-n1"
    }, [_vm._l(input.separate_counts ? [_vm.mdiHumanMale, _vm.iconPathChild] : [null], function (icon) {
      return _c('div', {
        staticClass: "my-1 d-flex align-center"
      }, [_c('v-text-field', {
        staticClass: "mr-3",
        attrs: {
          "dense": "",
          "outlined": "",
          "hide-details": "",
          "placeholder": "Name",
          "disabled": ""
        },
        scopedSlots: _vm._u([{
          key: "append",
          fn: function () {
            return [icon ? _c('v-btn', {
              staticStyle: {
                "margin-top": "-2px"
              },
              attrs: {
                "small": "",
                "icon": "",
                "disabled": ""
              }
            }, [_c('v-icon', {
              domProps: {
                "innerHTML": _vm._s(icon)
              }
            })], 1) : _vm._e()];
          },
          proxy: true
        }], null, true)
      }), _c('v-btn', {
        staticClass: "mr-n2",
        attrs: {
          "icon": "",
          "disabled": ""
        }
      }, [_c('v-icon', {
        domProps: {
          "innerHTML": _vm._s(_vm.mdiMinus)
        }
      })], 1)], 1);
    }), _c('div', {
      staticClass: "text-right mr-n2"
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "disabled": ""
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiPlus)
      }
    })], 1)], 1)], 2) : _vm._e()], 1)]);
  }), 0)], 1) : _vm._e(), _c('v-card-actions', [_c('v-menu', {
    attrs: {
      "right": "",
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-n2",
          attrs: {
            "fab": "",
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPlus)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right"
        }, [_vm._v("Add section…")])], 1)];
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "px-3 mb-1 text--label-active"
  }, [_vm._v("Add section")]), _vm.types.includes('HEADER') ? _c('v-list-item', {
    staticClass: "simple primary--text",
    on: {
      "click": function ($event) {
        return _vm.addSection({
          title: '',
          subtitle: '',
          type: 'HEADER',
          lock: ['public', 'required']
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTextShort)
    }
  }), _c('div', [_vm._v("Title / details")])], 1) : _vm._e(), _vm.types.includes('RADIO') ? _c('v-list-item', {
    staticClass: "simple primary--text",
    on: {
      "click": function ($event) {
        return _vm.addSection({
          title: '',
          subtitle: '',
          type: 'RADIO',
          choices: ['', '', ''],
          private: true
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiRadioboxMarked)
    }
  }), _c('div', [_vm._v("Multiple choice")])], 1) : _vm._e(), _vm.types.includes('INT') ? _c('v-list-item', {
    staticClass: "simple primary--text",
    on: {
      "click": function ($event) {
        return _vm.addSection({
          title: '',
          subtitle: '',
          type: 'INT',
          private: true,
          min: 0,
          max: 100
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiNumeric)
    }
  }), _c('div', [_vm._v("Number")])], 1) : _vm._e(), _vm.types.includes('TEXT') ? _c('v-list-item', {
    staticClass: "simple primary--text",
    on: {
      "click": function ($event) {
        return _vm.addSection({
          title: '',
          subtitle: '',
          type: 'TEXT',
          private: true
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCardTextOutline)
    }
  }), _c('div', [_vm._v("Text")])], 1) : _vm._e(), _vm.types.includes('EMAIL') ? _c('v-list-item', {
    staticClass: "simple primary--text",
    on: {
      "click": function ($event) {
        return _vm.addSection({
          title: '',
          subtitle: '',
          type: 'EMAIL',
          private: true
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAt)
    }
  }), _c('div', [_vm._v("Email")])], 1) : _vm._e()], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "warning"
    },
    on: {
      "click": function ($event) {
        _vm.showReset = true;
      }
    }
  }, [_vm._v("Reset…")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.tryClose
    }
  }, [_vm._v("Close")]), _c('v-btn', {
    class: {
      pulse: _vm.dirty
    },
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": !_vm.dirty
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Update")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }